import { useQuery } from '@tanstack/react-query';
import { getRstFixedDropdownOptions, getRstFixedPage } from './api.routes';

export function useRstFixedDropdownOptions(fundId: string | undefined) {
  return useQuery({
    queryKey: ['rst-fixed-dropdown-options', fundId],
    queryFn: () => getRstFixedDropdownOptions(fundId!),
    enabled: !!fundId,
  });
}

export function useRstFixedPage(
  fundId: string | undefined,
  positionDate: string | null | undefined,
  lrstKey: string | null | undefined,
) {
  return useQuery({
    queryKey: ['rst-fixed-page', fundId, lrstKey, positionDate],
    queryFn: () => getRstFixedPage(fundId!, lrstKey!, positionDate),
    enabled: !!fundId && !!lrstKey,
    staleTime: 1000 * 60 * 5,
  });
}
